/*  ========================================================================
    # Scripts - Request Modal
    ========================================================================  */

/**
 * Script that opens and closes the rquest modal.
 */

const RequestModal = {
  cfg: {
    triggerButtonElements: document.querySelectorAll(
      '[data-request-trigger], [href="#requestmodal"]'
    ),
    closeButtons: document.querySelectorAll('[data-request-close]'),
    requestModal: document.querySelector('.c-request-modal'),
    headerElement: document.querySelector('.c-header'),
    bodyElement: document.querySelector('body'),
    contentElement: document.querySelector('.c-request-modal__content'),
    formElement: document.querySelector('.c-request-modal__form'),
    formVehicleButtons: document.querySelectorAll('.c-request-modal__vehicle-button'),
    formErrorMessage: document.querySelector('.c-request-modal__error-message'),
    formFields: {
      fieldPhone: document.getElementById('phone'),
      fieldVehicle: document.getElementById('vehicles'),
      fieldUTMSource: document.getElementById('utm_source'),
      fieldUTMMedium: document.getElementById('utm_medium'),
      fieldUTMCampaign: document.getElementById('utm_campaign'),
      fieldUTMTerm: document.getElementById('utm_term'),
      fieldUTMContent: document.getElementById('utm_content'),
      fieldPageUrl: document.getElementById('page_url'),
      fieldLeadSource: document.getElementById('lead_source'),
      fieldPreviousPage: document.getElementById('previous_page'),
      fieldGclid: document.getElementById('gclid'),
      fieldConversionURL: document.getElementById('conversion_url')
    },
    states: {
      openHeader: 'c-header--open',
      openMenu: 'menu-open',
      openModal: 'modal-open'
    }
  },

  /**
   * Handle button click.
   */
  handleModalTrigger() {
    this.cfg.triggerButtonElements.forEach(button => {
      button.addEventListener('click', () => {
        if (
          this.cfg.headerElement &&
          this.cfg.bodyElement.classList.contains(this.cfg.states.openMenu)
        ) {
          this.cfg.headerElement.classList.remove(this.cfg.states.openHeader);
          this.cfg.bodyElement.classList.remove(this.cfg.states.openMenu);
        }
        this.cfg.requestModal.showModal();
        this.cfg.bodyElement.classList.add(this.cfg.states.openModal);
      });
    });
  },

  /**
   * Handle vehicle button click.
   */
  handleVehicleButton() {
    this.cfg.formVehicleButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.cfg.formFields.fieldVehicle.value = button.dataset.value;
        this.cfg.contentElement.dataset.formStep = 2;
      });
    });
  },

  /**
   * Fill hidden fields.
   */
  fillHiddenFields() {
    // Get all URL Parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Fill hidden fields
    this.cfg.formFields.fieldUTMSource.value = urlParams.get('utm_source');
    this.cfg.formFields.fieldUTMMedium.value = urlParams.get('utm_medium');
    this.cfg.formFields.fieldUTMCampaign.value = urlParams.get('utm_campaign');
    this.cfg.formFields.fieldUTMTerm.value = urlParams.get('utm_term');
    this.cfg.formFields.fieldUTMContent.value = urlParams.get('utm_content');
    this.cfg.formFields.fieldPageUrl.value = window.location.href;
    this.cfg.formFields.fieldLeadSource.value = urlParams.get('lead_source');
    this.cfg.formFields.fieldGclid.value = urlParams.get('gclid');
    this.cfg.formFields.fieldPreviousPage.value = document.referrer;
    this.cfg.formFields.fieldConversionURL.value = window.location.href;
  },

  /**
   * Form Submit.
   */
  async formSubmit(captchaToken) {
    const formData = new FormData(this.cfg.formElement);
    const formAction = this.cfg.formElement.getAttribute('data-action');
    formData.append('recaptchaToken', captchaToken);
    formData.append('formAction', formAction);
    this.cfg.requestModal.classList.add('c-request-modal--pending');

    try {
      const response = await fetch('/wp-json/vandy/v1/form/send/demoRequest', {
        method: 'POST',
        body: formData
      });

      if (response.ok && response.status === 200) {
        this.cfg.requestModal.classList.add('c-request-modal--success');
        this.cfg.requestModal.classList.remove('c-request-modal--pending');
        this.cfg.contentElement.dataset.formStep = 3;

        // Push Datalayer event
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ 'event': 'demo_form_submitted' });
      } else {
        this.cfg.requestModal.classList.remove('c-request-modal--pending');
        this.cfg.formErrorMessage.classList.add('visible');
      }
    } catch (error) {
      this.cfg.requestModal.classList.remove('c-request-modal--pending');
      console.error(error);
    }
  },

  /**
   * Initialize.
   */
  init() {
    // Handle trigger button click
    if (this.cfg.triggerButtonElements && this.cfg.requestModal) {
      this.handleModalTrigger();
    }

    // Handle vehicle button click
    if (this.cfg.formVehicleButtons && this.cfg.formVehicleButtons.length > 0) {
      this.handleVehicleButton();
    }

    // Handle close button click
    if (this.cfg.closeButtons && this.cfg.requestModal) {
      this.cfg.closeButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.cfg.requestModal.close();
          this.cfg.bodyElement.classList.remove(this.cfg.states.openModal);
        });
      });
    }

    // Handle phone input
    this.cfg.formFields.fieldPhone.addEventListener('blur', () => {
      this.cfg.formFields.fieldPhone.value = this.cfg.formFields.fieldPhone.value.replace(
        /[^0-9\+]/g,
        ''
      );
    });


    // Fill hidden fields
    this.fillHiddenFields();

    // Handle form submit
    if (this.cfg.formElement) {
      this.cfg.formElement.addEventListener('submit', e => {
        e.preventDefault();
        grecaptcha.ready(() => {
          grecaptcha
            .execute(window.jsLocalize.recaptchaSiteKey, { action: 'submit' })
            .then(token => {
              this.formSubmit(token);
            });
        });
      });
    }
  }
};

export default RequestModal;
